import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Onboarding from "@/pages/Onboarding";
import { Loader2 } from "lucide-react";

// Onboarding is auth-only (no onboarded check). Unauthenticated -> /login.
// Already-onboarded users -> dashboard.
export default function OnboardingRoute() {
  const { loading, user } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.onboarded) return <Navigate to="/" replace />;
  return <Onboarding />;
}
